/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWGameResponse } from './OWGameResponse';
import {
    OWGameResponseFromJSON,
    OWGameResponseFromJSONTyped,
    OWGameResponseToJSON,
    OWGameResponseToJSONTyped,
} from './OWGameResponse';
import type { PaginationInfo } from './PaginationInfo';
import {
    PaginationInfoFromJSON,
    PaginationInfoFromJSONTyped,
    PaginationInfoToJSON,
    PaginationInfoToJSONTyped,
} from './PaginationInfo';
import type { OWEventTypeResponse } from './OWEventTypeResponse';
import {
    OWEventTypeResponseFromJSON,
    OWEventTypeResponseFromJSONTyped,
    OWEventTypeResponseToJSON,
    OWEventTypeResponseToJSONTyped,
} from './OWEventTypeResponse';
import type { OWQuestResponse } from './OWQuestResponse';
import {
    OWQuestResponseFromJSON,
    OWQuestResponseFromJSONTyped,
    OWQuestResponseToJSON,
    OWQuestResponseToJSONTyped,
} from './OWQuestResponse';

/**
 * 
 * @export
 * @interface GetOverwolfQuestsResponse
 */
export interface GetOverwolfQuestsResponse {
    /**
     * 
     * @type {PaginationInfo}
     * @memberof GetOverwolfQuestsResponse
     */
    paginationInfo: PaginationInfo;
    /**
     * 
     * @type {Array<OWQuestResponse>}
     * @memberof GetOverwolfQuestsResponse
     */
    quests: Array<OWQuestResponse>;
    /**
     * 
     * @type {Array<OWEventTypeResponse>}
     * @memberof GetOverwolfQuestsResponse
     */
    allEventTypes: Array<OWEventTypeResponse>;
    /**
     * 
     * @type {Array<OWGameResponse>}
     * @memberof GetOverwolfQuestsResponse
     */
    allGames?: Array<OWGameResponse>;
}

/**
 * Check if a given object implements the GetOverwolfQuestsResponse interface.
 */
export function instanceOfGetOverwolfQuestsResponse(value: object): value is GetOverwolfQuestsResponse {
    if (!('paginationInfo' in value) || value['paginationInfo'] === undefined) return false;
    if (!('quests' in value) || value['quests'] === undefined) return false;
    if (!('allEventTypes' in value) || value['allEventTypes'] === undefined) return false;
    return true;
}

export function GetOverwolfQuestsResponseFromJSON(json: any): GetOverwolfQuestsResponse {
    return GetOverwolfQuestsResponseFromJSONTyped(json, false);
}

export function GetOverwolfQuestsResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetOverwolfQuestsResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'paginationInfo': PaginationInfoFromJSON(json['paginationInfo']),
        'quests': ((json['quests'] as Array<any>).map(OWQuestResponseFromJSON)),
        'allEventTypes': ((json['allEventTypes'] as Array<any>).map(OWEventTypeResponseFromJSON)),
        'allGames': json['allGames'] == null ? undefined : ((json['allGames'] as Array<any>).map(OWGameResponseFromJSON)),
    };
}

export function GetOverwolfQuestsResponseToJSON(json: any): GetOverwolfQuestsResponse {
    return GetOverwolfQuestsResponseToJSONTyped(json, false);
}

export function GetOverwolfQuestsResponseToJSONTyped(value?: GetOverwolfQuestsResponse | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'paginationInfo': PaginationInfoToJSON(value['paginationInfo']),
        'quests': ((value['quests'] as Array<any>).map(OWQuestResponseToJSON)),
        'allEventTypes': ((value['allEventTypes'] as Array<any>).map(OWEventTypeResponseToJSON)),
        'allGames': value['allGames'] == null ? undefined : ((value['allGames'] as Array<any>).map(OWGameResponseToJSON)),
    };
}

